import { parseFilterRecords } from "./filter";
import { readHexInt } from "./hex";
import { getProtocolString } from "./source";

export function createSystemSettings() {
  return {
    jinShuiYaLiDi: "",
    chunShuiXiangZhiShuiTingZhi: "",
    chunShuiXiangZhiShuiQiDong: "",
    moChongXiShiChang: "",
    moQianYaLiGao: "",
    gongShuiYaLiDi: "",
    gongShuiBangQiDong: "",
    gongShuiBangTingZhi: "",
    chunShuiXiangPaiKong: "",
    jinShuiLiuLiangXiShu: "",
    chunShuiLiuLiangXiShu: "",
    gongShuiLiuLiangXiShu: "",
    zhiShuiChongXiJianGe: "",
    jinShuiYaLiGao: "",
    chunShuiXiangGongShuiQiDong: "",
    chunShuiXiangGongShuiTingZhi: "",
    chunShuiXunHuanJianGe: "",
    chunShuiXunHuanShiChang: ""
  };
}

export function parseSystemSettings(protocol) {
  const parameters = getProtocolString(protocol, "runParameters");
  if (!parameters) {
    return createSystemSettings();
  }

  const value = (start, length = 2) => String(readHexInt(parameters, start, length));

  return {
    jinShuiYaLiDi: value(2),
    chunShuiXiangZhiShuiTingZhi: value(52),
    chunShuiXiangZhiShuiQiDong: value(54),
    moChongXiShiChang: value(46),
    moQianYaLiGao: value(4),
    gongShuiYaLiDi: value(10),
    gongShuiBangQiDong: value(18),
    gongShuiBangTingZhi: value(20),
    chunShuiXiangPaiKong: value(88),
    jinShuiLiuLiangXiShu: value(66),
    chunShuiLiuLiangXiShu: value(70),
    gongShuiLiuLiangXiShu: value(62),
    zhiShuiChongXiJianGe: value(78),
    jinShuiYaLiGao: value(90),
    chunShuiXiangGongShuiQiDong: value(56),
    chunShuiXiangGongShuiTingZhi: value(58),
    chunShuiXunHuanJianGe: value(6),
    chunShuiXunHuanShiChang: value(14)
  };
}

export function createTimingSettings() {
  const settings = { setIntervalDays: "", accumulatedDays: "" };

  for (let period = 1; period <= 3; period += 1) {
    settings[`waterReturnValveStartHour${period}`] = "";
    settings[`waterReturnValveStartMinute${period}`] = "";
    settings[`waterReturnValveEndHour${period}`] = "";
    settings[`waterReturnValveEndMinute${period}`] = "";
    settings[`deviceStartHour${period}`] = "";
    settings[`deviceStartMinute${period}`] = "";
    settings[`deviceEndHour${period}`] = "";
    settings[`deviceEndMinute${period}`] = "";
  }

  return settings;
}

export function parseTimingSettings(protocol) {
  const parameters = getProtocolString(protocol, "runParameters");
  if (!parameters) {
    return createTimingSettings();
  }

  const settings = createTimingSettings();
  settings.setIntervalDays = String(readHexInt(parameters, 108, 2));
  settings.accumulatedDays = String(readHexInt(parameters, 110, 2));

  let offset = 112;
  for (let period = 1; period <= 3; period += 1) {
    [
      `waterReturnValveStartHour${period}`,
      `waterReturnValveStartMinute${period}`,
      `waterReturnValveEndHour${period}`,
      `waterReturnValveEndMinute${period}`,
      `deviceStartHour${period}`,
      `deviceStartMinute${period}`,
      `deviceEndHour${period}`,
      `deviceEndMinute${period}`
    ].forEach(field => {
      settings[field] = String(readHexInt(parameters, offset, 2));
      offset += 2;
    });
  }

  return settings;
}

export function createClockSettings() {
  return { year: "", month: "", day: "", hour: "", minute: "" };
}

export function parseClockSettings(protocol) {
  const source = getProtocolString(protocol, "hostTime");
  if (!source) {
    return createClockSettings();
  }

  return {
    year: String(readHexInt(source, 0, 2)),
    month: String(readHexInt(source, 2, 2)),
    day: String(readHexInt(source, 4, 2)),
    hour: String(readHexInt(source, 6, 2)),
    minute: String(readHexInt(source, 8, 2))
  };
}

export function createFilterSettings() {
  return {
    quartzSandFlow: "",
    quartzSandDays: "",
    activatedCarbonFlow: "",
    activatedCarbonDays: "",
    softeningResinFlow: "",
    softeningResinDays: "",
    regenerationSaltFlow: "",
    regenerationSaltDays: "",
    roMembraneFlow: "",
    roMembraneDays: "",
    precisionFilterFlow: "",
    precisionFilterDays: ""
  };
}

export function parseFilterSettings(protocol) {
  if (!getProtocolString(protocol, "filter")) {
    return createFilterSettings();
  }

  const records = parseFilterRecords(protocol);
  const getRecord = key => records.find(item => item.key === key) || {};
  const sand = getRecord("quartzSand");
  const carbon = getRecord("activatedCarbon");
  const resin = getRecord("softeningResin");
  const salt = getRecord("regenerationSalt");
  const membrane = getRecord("roMembrane");
  const precisionFilter = getRecord("precisionFilter");

  return {
    quartzSandFlow: sand.settingFlowRaw,
    quartzSandDays: sand.settingDays,
    activatedCarbonFlow: carbon.settingFlowRaw,
    activatedCarbonDays: carbon.settingDays,
    softeningResinFlow: resin.settingFlowRaw,
    softeningResinDays: resin.settingDays,
    regenerationSaltFlow: salt.settingFlowRaw,
    regenerationSaltDays: salt.settingDays,
    roMembraneFlow: membrane.settingFlowRaw,
    roMembraneDays: membrane.settingDays,
    precisionFilterFlow: precisionFilter.settingFlowRaw,
    precisionFilterDays: precisionFilter.settingDays
  };
}
